<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="colWidth">
                <div
                    style="
                        height:80px;
                        padding:0 20px;margin-bottom:20px;
                        position: relative;
                    "
                    class="total_b1"
                >
                    <div class="total_num">15000</div>
                    <div class="total_name">总订单量(双)</div>
                    <img class="total_pic" src="../../assets/p1.png" />
                </div>
            </el-col>
            <el-col :span="colWidth">
                <div
                    style="
                        height:80px;
                        padding:0 20px;margin-bottom:20px;
                        position: relative;
                    "
                    class="total_b2"
                >
                    <div class="total_num">15000</div>
                    <div class="total_name">总订单量(双)</div>
                    <img class="total_pic" src="../../assets/p2.png" />
                </div>
            </el-col>
            <el-col :span="colWidth">
                <div
                    style="
                        height:80px;
                        padding:0 20px;margin-bottom:20px;
                        position: relative;
                    "
                    class="total_b3"
                >
                    <div class="total_num">15000</div>
                    <div class="total_name">总订单量(双)</div>
                    <img class="total_pic" src="../../assets/p3.png" />
                </div>
            </el-col>
            <el-col :span="colWidth">
                <div
                    style="
                        height:80px;
                        padding:0 20px;margin-bottom:20px;
                        position: relative;
                    "
                    class="total_b4"
                >
                    <div class="total_num">15000</div>
                    <div class="total_name">总订单量(双)</div>
                    <img class="total_pic" src="../../assets/p4.png" />
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="echartWidth">
                <st1 ref="st1"></st1>
            </el-col>
            <el-col :span="echartWidth">
                <st2 ref="st2"></st2>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="echartWidth">
                <st3 ref="st3"></st3>
            </el-col>
            <el-col :span="echartWidth">
                <st4 ref="st4"></st4>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="echartWidth">
                <st5 ref="st5"></st5>
            </el-col>
            <el-col :span="echartWidth">
                <st6 ref="st6"></st6>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import st1 from "./st1.vue";
import st2 from "./st2.vue";
import st3 from "./st3.vue";
import st4 from "./st4.vue";
import st5 from "./st5.vue";
import st6 from "./st6.vue";
export default {
    components:{
        st1,
        st2,
        st3,
        st4,
        st5,
        st6,
    },
    data(){
        return{
            colWidth:6,
            echartWidth:12,
        }
    },
    created(){
        let clientWidth = document.documentElement.clientWidth;
        if(clientWidth>1280){
            this.echartWidth = 12;
        }else{
            this.echartWidth = 24;
        }
        if(clientWidth<768){
            this.colWidth = 24;
        }else if(clientWidth<1024){
            this.colWidth = 12;
        }else{
            this.colWidth = 6;
        }
    },
    mounted(){
        let _this = this;
        window.onresize = function(){
            _this.$nextTick(()=>{
                let clientWidth = document.documentElement.clientWidth;
                if(clientWidth>1280){
                    _this.echartWidth = 12;
                }else{
                     _this.echartWidth = 24;
                }
                if(clientWidth<768){
                    _this.colWidth = 24;
                }else if(clientWidth<1024){
                     _this.colWidth = 12;
                }else{
                    _this.colWidth = 6;
                }
            })
        }
        this.getInfo();
    },
    methods:{
        getInfo:function(){
            this.$api.panelData().then(res=>{
                if(res.data.code==1){
                    this.$refs.st1.init();
                    this.$refs.st2.init();
                    this.$refs.st3.init();
                    this.$refs.st4.init();
                    this.$refs.st5.init();
                    this.$refs.st6.init();
                }
            })
        },
    },
}
</script>

<style scoped>
.total_num{
    padding-top: 10px;
    line-height: 30px;
    font-size: 24px;
    color: #fff;
}
.total_pic{
    width: 50px;
    height: 50px;
    position: absolute;
    
    top: 15px;
    right: 15px;
}
.total_b1{
    background: url('../../assets/b1.png');
    background-size: 100% 100%;
}
.total_b2{
    background: url('../../assets/b2.png');
    background-size: 100% 100%;
}
.total_b3{
    background: url('../../assets/b3.png');
    background-size: 100% 100%;
}
.total_b4{
    background: url('../../assets/b4.png');
    background-size: 100% 100%;
}
.total_name{
    line-height: 30px;
    font-size: 14px;
    color: #fff;
}
</style>